import React from 'react';
import * as Ant from 'antd';
import {DialogWrapper, Button, Title} from '../DialogWidgets';
import * as AppActions from '../../AppActions';

const L = AppActions.L;

class TermsDialog extends React.Component {
  render() {
    let {closeDialog, show} = this.props;

    return (
      <Ant.Modal
        visible={show}
        title={<Title>{L('terms_title')}</Title>}
        footer={
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
            }}>
            <Ant.Button css="margin: 10px;" onClick={() => closeDialog()}>
              {L('confirm')}
            </Ant.Button>
          </div>
        }
        closeIcon={<p>X</p>}
        onCancel={closeDialog}
        width="80%">
        <DialogWrapper>
          <div
            className="content"
            style={{whiteSpace: 'pre-wrap', paddingTop: 5}}>
            <p
              style={{
                whiteSpace: 'break-spaces',
              }}>
              {L('terms_kickoff')}
            </p>
            <p
              className="subtitle"
              style={{paddingLeft: 0, fontWeight: 'bold'}}>
              {L('terms_topic_1')}
            </p>
            <p
              style={{
                whiteSpace: 'break-spaces',
              }}>
              {L('terms_topic_1_content')}
            </p>

            <p
              className="subtitle"
              style={{paddingLeft: 0, fontWeight: 'bold'}}>
              {L('terms_topic_2')}
            </p>

            <p
              style={{
                whiteSpace: 'break-spaces',
              }}>
              {L('terms_topic_2_content')}
            </p>

            <p
              className="subtitle"
              style={{paddingLeft: 0, fontWeight: 'bold'}}>
              {L('terms_topic_3')}
            </p>
            <p
              style={{
                whiteSpace: 'break-spaces',
              }}>
              {L('terms_topic_3_content')}
            </p>
          </div>
        </DialogWrapper>
      </Ant.Modal>
    );
  }
}

export default TermsDialog;
